import * as THREE from 'three';

export default class RaycasterController {
  constructor(camera) {

    this._camera = camera;

    this._raycaster = null;
    this._meshes = [];
    this._mousePosition = new THREE.Vector2();

    this._init();
  }

  getRaycaster() {
    return this._raycaster;
  }

  checkIntersection(x, y) {
    this._mousePosition.set(
      (x / window.innerWidth) * 2 - 1,
      -(y / window.innerHeight) * 2 + 1
    );

    this._raycaster.setFromCamera(this._mousePosition, this._camera);
    const intersects = this._raycaster.intersectObjects(this._meshes);

    return intersects.length > 0 ? intersects[0] : null;
  }

  addMeshes(meshes) {
    this._meshes = [...this._meshes, ...meshes];
  }

  _init() {
    this._raycaster = new THREE.Raycaster();
  }
}
